import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface CreateTextBlockCriteria {
    dashboardId: string;
    richText: string;
}

class CreateTextBlockCriteriaImpl implements CreateTextBlockCriteria {
    constructor(readonly richText: string, readonly dashboardId: string) {}
}

export class CreateTextBlockCriteriaBuilder {
    private richText: Option<string> = none;

    private dashboardId: Option<string> = none;

    static create = (): CreateTextBlockCriteriaBuilder => new CreateTextBlockCriteriaBuilder();

    withRichText = (richText: string): CreateTextBlockCriteriaBuilder => {
        this.richText = some(richText);
        return this;
    };

    withDashboardId = (dashboardId: string): CreateTextBlockCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    build = (): CreateTextBlockCriteria => {
        if (isNone(this.richText) || isNone(this.dashboardId)) {
            throw new ReferenceError('Undefined prop');
        }

        return new CreateTextBlockCriteriaImpl(this.richText.value, this.dashboardId.value);
    };
}
